// eslint-disable-next-line import/no-named-as-default
import { Icon } from "@mdi/react";

import { mdiAccount, mdiDomain, mdiHomeLightbulb } from "@mdi/js";
import {
  POLYGON_BINS_MY_FIELDS_LAYERS,
  POLYGON_BINS_ORG_FIELDS_LAYERS,
  POLYGON_BINS_PROJECT_FIELDS_LAYERS
} from "constants/mapLayers.constants";
import styled from "styled-components";

import { EntityKind } from "models/entityKind";

import useTileColumns from "components/filter/hooks/useTileColumns";
import { IconSpinner } from "components/icons";

import { FlexItem, NodeTitle } from "../../../../shared/nodes/StyledNodePartials";

export interface IPolygonBinFolder {
  node;
}

export function PolygonBinFolder({ node }: IPolygonBinFolder) {
  const { isLoading } = useTileColumns(EntityKind.Well);
  return (
    <NodeTitle className="visible-always">
      <FlexItem>
        {node.key === POLYGON_BINS_MY_FIELDS_LAYERS && (
          <StyledIcon path={mdiAccount} className="activity-action-icon" size={1} />
        )}
        {node.key === POLYGON_BINS_ORG_FIELDS_LAYERS && (
          <StyledIcon path={mdiDomain} className="activity-action-icon" size={1} />
        )}
        {node.key === POLYGON_BINS_PROJECT_FIELDS_LAYERS && (
          <StyledIcon
            path={mdiHomeLightbulb}
            className="activity-action-icon"
            size={"16px"} //slightly larger to visually match other icons
          />
        )}

        <label>{node.title}</label>

        {isLoading && <StyledSpinner />}
      </FlexItem>
    </NodeTitle>
  );
}

const StyledIcon = styled(Icon)`
  cursor: default;
  color: #a2aaad;
`;

const StyledSpinner = styled(IconSpinner)`
  width: 13px;
  height: 13px;
`;
